module.exports = __webpack_public_path__ + "img/06.4c2a7c03.png";